var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-table",class:{ 'not-border-bottom': _vm.notBorderBottom, 'border-top': _vm.borderTop }},[_c('table',{class:{ [_vm.customClass]: true, 'header-dark': _vm.darkHeader }},[_c('thead',[_vm._t("head")],2),_c('tbody',[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }